import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  const bullets = ['Ingredientes de Mercadona, Lidl y Carrefour', 'Pan, pizza y pasta con sabor real', '21 días para notar la diferencia'];
  return <div className="w-full max-w-full overflow-x-hidden" data-id="element-103" data-mp="1286262e70it6">
      {/* MOBILE — designed specifically for small viewports, not a compressed desktop */}
      <div className="md:hidden w-full max-w-full pt-5 pb-6" data-id="element-104" data-mp="sbb1bcug66bq">
        <div className="text-center px-4 max-w-full" data-id="element-105" data-mp="s9ggdyj6ee7n">
          <div className="inline-flex items-center gap-1.5 bg-white border border-brand-border rounded-full px-3 py-1 text-brand-primary font-semibold text-[10px] tracking-[0.1em] uppercase mb-3 shadow-sm" data-id="element-106" data-mp="ncq29gqxlsov">
            Sistema práctico · 100% digital · Para España
          </div>

          <h1 className="font-display text-brand-title font-bold tracking-tight mb-3 text-[26px] leading-[1.22] max-w-full" data-id="element-107" data-mp="3j8sdfvbir9n7">
            Llevas meses{' '}
            <span className="text-brand-primary" data-id="element-108" data-mp="3o73p8bldju82">quitando el gluten.</span>
            <br data-id="element-109" data-mp="399bahlnnj9ux" />
            Nadie te enseñó a{' '}
            <span className="text-brand-secondary" data-id="element-110" data-mp="39cpa4m4xl4yo">reemplazarlo.</span>
          </h1>

          <p className="text-[13.5px] text-brand-text mb-4 leading-snug font-body max-w-[320px] mx-auto" data-id="element-111" data-mp="3ebiqcmblra2j">
            Aprende a reconstruir pan, pizza, pasta y dulces con ingredientes
            que no te inflamen. Sin comer raro. Sin dar explicaciones. Sin
            volver a ser "la rara de la mesa".
          </p>
        </div>

        <div className="w-full flex justify-center px-4 max-w-full mb-4" data-id="element-112" data-mp="2viojygs1oq9x">
          <div className="relative w-[92%] max-w-[380px] aspect-square" data-id="element-113" data-mp="2vglld8cttotl">
            <img src="https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png" alt="Sistema Mimetismo Nutricional™ — 6 Tomos + 6 Bonos Exclusivos" width="800" height="800" fetchPriority="high" loading="eager" decoding="sync" className="w-full h-full object-contain" data-id="element-114" data-mp="2hjypl8wm14p9" />
          </div>
        </div>

        <div className="text-center px-4 max-w-full" data-id="element-115" data-mp="ibow6f6accrq">
          <div className="flex flex-wrap justify-center gap-1.5 mb-4" data-id="element-116" data-mp="ia5jsznr2lv8">
            {bullets.map((b, i) => <span key={i} className="inline-flex items-center gap-1 bg-white border border-brand-border rounded-full px-2.5 py-1 text-[11px] text-brand-text font-body whitespace-nowrap" data-id="element-117" data-mp="db2cf8kas3k3" data-mpi={i}>
                <span className="text-brand-primary font-bold" data-id="element-118" data-mp="162m0b5rua5sf">✓</span>
                {b}
              </span>)}
          </div>

          <button onClick={scrollToPricing} className="bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-base py-3.5 rounded-xl transition-colors w-full shadow-card-lg mb-2.5" data-id="element-119" data-mp="x14o3yhjyo90">
            Quiero aprender a reemplazar →
          </button>

          <div className="text-brand-textMuted font-medium text-[11px] tracking-wide mb-4" data-id="element-120" data-mp="3hq266xcxa69u">
            Acceso inmediato · Pago único · Garantía 30 días
          </div>

          <p className="text-brand-text text-[12px] font-body leading-snug max-w-[300px] mx-auto" data-id="element-121" data-mp="21bxzf8gseycx">
            Más de 1.200 personas en España ya están comiendo pan, pasta y
            pizza sin gluten sin sentirlo como un sacrificio.
          </p>
        </div>
      </div>

      {/* DESKTOP — two-column composition */}
      <div className="hidden md:block w-full max-w-full pt-10 pb-14 px-4" data-id="element-122" data-mp="2fzarzh50i4ct">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center" data-id="element-123" data-mp="2kxuebinipi5p">
          {/* Left column — copy */}
          <div className="text-left" data-id="element-124" data-mp="2p10imkr2kz9j">
            <div className="inline-flex items-center gap-2 bg-white border border-brand-border rounded-full px-4 py-1.5 text-brand-primary font-semibold text-xs tracking-[0.15em] uppercase mb-6 shadow-sm" data-id="element-125" data-mp="2tzlj8la8hkyi">
              Sistema práctico · 100% digital · Para España
            </div>

            <h1 className="font-display text-brand-title font-bold tracking-tight mb-5 text-[44px] lg:text-[50px] leading-[1.15]" data-id="element-126" data-mp="zndq9dhh3e5d">
              Llevas meses{' '}
              <span className="text-brand-primary" data-id="element-127" data-mp="3vh5lsbw8lg9u">quitando el gluten.</span>
              <br data-id="element-128" data-mp="e9tn5glefex2" />
              Nadie te enseñó a{' '}
              <span className="text-brand-secondary" data-id="element-129" data-mp="e77ipptt1fj2">reemplazarlo.</span>
            </h1>

            <p className="text-lg text-brand-text mb-6 leading-relaxed max-w-xl font-body" data-id="element-130" data-mp="98e2hpn4vaf7">
              Aprende a reconstruir pan, pizza, pasta y dulces con
              ingredientes que no te inflamen. Sin comer raro. Sin dar
              explicaciones. Sin volver a ser "la rara de la mesa".
            </p>

            <div className="flex flex-wrap items-center gap-2.5 mb-8" data-id="element-131" data-mp="3mpdf8cac2raj">
              {bullets.map((b, i) => <span key={i} className="inline-flex items-center gap-1.5 bg-white border border-brand-border rounded-full px-3.5 py-1.5 text-sm text-brand-text font-body whitespace-nowrap" data-id="element-132" data-mp="3mnivv2epn78k" data-mpi={i}>
                  <span className="text-brand-primary font-bold" data-id="element-133" data-mp="2tyve3gt66zzr">✓</span>
                  {b}
                </span>)}
            </div>

            <button onClick={scrollToPricing} className="bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-xl py-4 px-10 rounded-xl transition-colors w-auto shadow-card-lg" data-id="element-134" data-mp="1e9vquuay86b7">
              Quiero aprender a reemplazar →
            </button>

            <div className="text-brand-textMuted font-medium text-sm tracking-wide mt-4 mb-3" data-id="element-135" data-mp="1s958lyesz8ha">
              Acceso inmediato · Pago único · Garantía 30 días
            </div>

            <p className="text-brand-text text-sm font-body leading-relaxed max-w-md" data-id="element-136" data-mp="1x65fucne2h9z">
              Más de 1.200 personas en España ya están comiendo pan, pasta y
              pizza sin gluten sin sentirlo como un sacrificio.
            </p>
          </div>

          {/* Right column — mockup with subtle gastronomic collage */}
          <div className="relative flex justify-end" data-id="element-137" data-mp="bun9pj1wuqif">
            <div className="relative w-full max-w-lg aspect-square" data-id="element-138" data-mp="bw8335cho3ep">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/e5fc5124-93ef-444b-a413-4c5df04d17c9.jpg" alt="" aria-hidden="true" className="absolute -top-4 -left-6 w-36 h-36 rounded-full object-cover opacity-30 blur-[1px] grayscale-[15%] -z-10" data-id="element-139" data-mp="2egirq64dw8cz" />
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/7ad5ad3d-7c30-45b6-974b-34f44ab275b1.jpg" alt="" aria-hidden="true" className="absolute top-2 -right-8 w-32 h-32 rounded-full object-cover opacity-25 blur-[1px] grayscale-[15%] -z-10" data-id="element-140" data-mp="1zso2izpl4m4n" />
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/2dc28840-75d6-4cc2-bdc0-2ed41966abc2.jpg" alt="" aria-hidden="true" className="absolute -bottom-6 -right-4 w-36 h-36 rounded-full object-cover opacity-25 blur-[1px] grayscale-[15%] -z-10" data-id="element-141" data-mp="1qqohlwbg8xwf" />
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/e0ee02ce-49ea-49ff-bbc5-eb9cd79067b8.jpg" alt="" aria-hidden="true" className="absolute bottom-0 -left-8 w-28 h-28 rounded-full object-cover opacity-25 blur-[1px] grayscale-[15%] -z-10" data-id="element-142" data-mp="3g5uyfhguw0dg" />

              <img src="https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png" alt="Sistema Mimetismo Nutricional™ — 6 Tomos + 6 Bonos Exclusivos" width="800" height="800" fetchPriority="high" loading="eager" decoding="sync" className="relative z-10 w-full h-full object-contain drop-shadow-xl" data-id="element-143" data-mp="3nq6ypimoq1if" />

              <div className="absolute bottom-6 left-4 z-20 bg-brand-primary text-white text-sm font-heading font-bold tracking-wide px-4 py-2 rounded-full shadow-card whitespace-nowrap" data-id="element-144" data-mp="30rsmbjae3q5g">
                6 Tomos + Bonos
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}